// auto-generated by Typewriter template _enums.tst from PortCall.Models\TopicCards\TopicCardTemplate.cs
export enum TopicCardQuestionType { 
    YesNo = 1,
    MultipleChoice = 2
}

export const TopicCardQuestionTypeDisplayName : { [val : number] : string } = { 
    1: 'YesNo',
    2: 'MultipleChoice'
}

export const TopicCardQuestionTypes : { Id : TopicCardQuestionType, Name : string }[] = [ 
    { Id: TopicCardQuestionType.YesNo, Name: 'YesNo' },
    { Id: TopicCardQuestionType.MultipleChoice, Name: 'MultipleChoice' }
]



// WEBPACK FOOTER //
// ./server/enums/TopicCardQuestionType.ts